module.exports = __webpack_public_path__ + "img/madera003.fb6fea03.jpg";